import { ZipApiTimeoutError } from './ZipApiTimeoutError';

export class ZipApiError extends Error {
  constructor(public response: Response, message?: string) {
    super(message || `${response.status} ${response.statusText}`);
  }
}

export async function getApiErrorMessage(error: any, context: string): Promise<string> {
  if (error instanceof ZipApiTimeoutError) {
    return `${context}: the request timed out. Please try again.`;
  }
  if (error instanceof ZipApiError && error.response) {
    if (error.response.status === 504) {
      return `${context}: the request timed out. Please try again.`;
    }
    try {
      const body = await error.response.json();
      const detail = body.message || body.error;
      // Content Graph credentials need time to replicate after initial setup,
      // causing temporary 401s. Show a friendlier message so users know to wait.
      if (error.response.status === 401 && detail && detail.includes('Graph unauthorized')) {
        return `${context}: Graph authentication is being set up. This usually takes a few minutes — please try again shortly.`;
      }
      if (detail) return `${context}: ${detail}`;
    } catch {
      // response body wasn't JSON, use fallback
    }
  }
  return `${context}: an unexpected error occurred.`;
}
